<template>
  <div>

    <StepActionDialog dialog-id="modal-action-step-set-operation-status" @onSubmit="onSubmitStepAction"
                      type="set_operationStatus"
                      :production-order-batch-step-id="stepCurrentId"/>

    <ProductionOrderStepDialog :production-order-batch-step-id="dialogStepDetailId"
                                     only-view
                                     @onClose="dialogStepDetailShow = false" v-if="dialogStepDetailShow"/>

    <b-card class="mb-2" v-if="!StatusProductionOrderType.hasDone(statusOrder)">

      <b-row>
        <b-col cols="12">

          <b-card-title>Status Operacional</b-card-title>

          <div v-if="!stepsFlowLoadingFinish || busy">
            <div class="container_loading_form_card" style="height: 30px">
              <div class="gradient element-100" style="margin-top:0px; height: 30px"></div>
            </div>

          </div>

          <div v-else-if="statusProductionColor !== ''"
               class="d-flex link link-shadow"
               @click="stepActionSetOperationStatus"
               v-b-tooltip.hover.ds500 title="Clique caso desejar alterar o status manualmente"
               style="border: solid 1px; padding: 10px; border-radius: 5px"
               :style="{'border-color':statusProductionColor}">

            <span class="badge badge-dot badge-dot-xl mr-2"
                  style="margin-top:2px"
                  :style="{'background-color': statusProductionColor}"></span>
            <div style="font-size: 13px;"> {{ statusProduction }}</div>

          </div>

          <div v-else-if="statusProductionColor !== '' && StatusProductionOrderType.hasDone(statusBatch)"
               class="d-flex"
               style="border: solid 1px; padding: 10px; border-radius: 5px"
               :style="{'border-color':statusProductionColor}">

            <span class="badge badge-dot badge-dot-xl mr-2"
                  style="margin-top:2px"
                  :style="{'background-color': statusProductionColor}"></span>
            <div style="font-size: 13px;"> {{ statusProduction }}</div>

          </div>


        </b-col>

      </b-row>

    </b-card>

    <b-card>

      <b-row>

        <b-col cols="8">

          <b-card-title>Etapas</b-card-title>

        </b-col>

        <b-col cols="4" class="d-flex align-items-end justify-content-end">
          <t-button outline-light @click="getFlowByBatchId">
            <b-icon-arrow-counterclockwise/>
          </t-button>
        </b-col>

      </b-row>


      <div
          style="overflow-x:visible"
          :style="{'max-height':maxHeightSteps !== '' ? maxHeightSteps : 'auto', 'overflow-y':maxHeightSteps !== '' ? 'auto' : 'visible'}">


        <div v-if="stepsFlowLoadingFinish && !busy && stepsFlow.length === 0">

          <t-msg info v-if="stepsFlow.length === 0" class="mt-3">Não há fluxo de etapas neste tipo de ordem de fabricação</t-msg>

        </div>

        <div
            v-else-if="stepsFlowLoadingFinish && !busy"
            class="vertical-time-icons vertical-timeline vertical-timeline--animate vertical-timeline--one-column">


          <div v-for="(item,index) in stepsFlow"  :key="index"
               class="vertical-timeline-item vertical-timeline-element">

            <div>

              <div class="vertical-timeline-element-icon bounce-in">

                <div class="timeline-icon"
                     v-b-tooltip.hover='"Etapa sequêncial"'
                     :class="{
                        'badge-border-gray':item.statusStep === StatusStepType.type.PENDING,
                        'badge-border-green':item.statusStep === StatusStepType.type.DONE,
                      }" v-if="item.stepSequential && item.statusStep !== StatusStepType.type.CURRENT">
                  <b-icon-check-lg class="badge-text-gray" v-if="item.statusStep === StatusStepType.type.DONE"/>

                </div>

                <div class="timeline-icon badge-border-blue"
                     v-else-if="item.stepSequential && item.statusStep === StatusStepType.type.CURRENT">
                  <b-icon-pin v-b-tooltip.hover='"Etapa sequêncial e atual no momento"' class="badge-text-blue"/>

                </div>

                <div class="timeline-icon badge-border-purple"
                     v-b-tooltip.hover='"Etapa em paralelo"'
                     v-else-if="item.typeActionNotSequential === FlowStepNotSequenceActionType.type.EXECUTION_PARALLEL">
                  <b-icon-check-lg class="badge-text-purple" v-if="item.statusStep === StatusStepType.type.DONE"/>
                </div>

                <div class="timeline-icon badge-border-green"
                     v-b-tooltip.hover='"Etapa de inspeção de expedição"'
                     v-else-if="item.typeActionNotSequential === FlowStepNotSequenceActionType.type.FINAL_INSPECTION_SHIPPING">
                  <b-icon-check-lg class="badge-text-dark" v-if="item.statusStep === StatusStepType.type.DONE"/>
                </div>

                <div class="timeline-icon badge-border-dark"
                     v-else>
                  <b-icon-check-lg v-b-tooltip.hover='"Etapa de correção realizada"' class="badge-text-dark"
                                   v-if="item.statusStep === StatusStepType.type.DONE"/>
                  <b-icon-pin v-b-tooltip.hover='"Etapa de correção atual no momento"' class="badge-text-dark"
                              v-else-if="item.statusStep === StatusStepType.type.CURRENT"/>
                </div>
              </div>

              <div class="vertical-timeline-element-content bounce-in">

                <h4 class="timeline-title">
                  {{ item.name }} <span class="badge badge-danger ml-2"
                                        v-if="item.lastNonConformanceQtyFields > 0">{{
                    ui.formatZeroNumber(item.lastNonConformanceQtyFields, 2)
                  }}</span>
                </h4>

                <p>

                        <span
                            v-if="item.shotLastStart !== '' && item.shotLastStart !== undefined && (item.statusStep === StatusStepType.type.DONE || item.statusStep === StatusStepType.type.CURRENT)">

                          <b-icon-clock class="mr-2" v-b-tooltip.hover='"Tempo até a finalização da etapa"'
                                        v-if="item.statusStep === StatusStepType.type.DONE"/>
                          <b-icon-clock class="mr-2" v-b-tooltip.hover='"Tempo desde o início até agora"'
                                        v-else-if="item.statusStep === StatusStepType.type.CURRENT"/>
                          {{ item.shotLastTimeOrNow | minuteOrHour }}
                          <!--(tempo percorrido até o momento ou até finalização se estiver finalizado) --><br/>
                        </span>


                  <b-icon-people class="mr-2" v-b-tooltip.hover='"Grupo(s) responsável"'/>
                  {{ item.responsibleName }}<br/>

                  <span v-if="item.operator !== '' && item.operator !== undefined"
                        v-b-tooltip.hover='"Operador responsável"'>
                          <b-icon-person class="mr-2"/>
                        {{ item.operator }}
                        </span>

                </p>

                <t-button small outline-light @click="openDialogStepDetail(item.productionOrderBatchStepId)">
                  Detalhar
                </t-button>

                <b-button class="ml-2" v-if="item.statusStep === StatusStepType.type.CURRENT && originOrderForm"
                          :to="{path: '/' + currentPage.path + '-step/' + item.productionOrderBatchStepId}"
                          variant="outline-primary" size="sm" target="_blank">
                  <b-icon-box-arrow-up-right class="mr-2"/>
                  Abrir
                </b-button>


              </div>

            </div>


          </div>

        </div>

        <div v-else-if="!stepsFlowLoadingFinish || busy">
          <div class="container_loading_form_card">

            <div class="gradient element-60"></div>

            <div class="gradient element-80"></div>


          </div>

        </div>

        <t-msg class="mt-2" v-else info>Nenhuma etapa inserida nesta ordem!</t-msg>

      </div>


    </b-card>

  </div>
</template>
<script>
import ui from "@/assets/scripts/ui";
import StatusStepType from "@/model/types/modules/production/StatusStepType";
import FlowStepNotSequenceActionType from "@/model/types/modules/production/FlowStepNotSequenceActionType";
import StatusProductionOrderType from "@/model/types/modules/production/StatusProductionOrderType";
import ProductionOrderBatchService from "@/services/modules/production/ProductionOrderBatch.service";
import ProductionOrderStepDialog
  from "@/views/modules/production/ProductionOrder/dialog/ProductionOrderStepDialog";
import functionsMixins from "@/mixins/page/functionsMixins";
import StepActionDialog from "@/views/modules/production/ProductionOrder/components/StepActionDialog";


export default {
  name: 'ProductionBatchFlow',
  mixins: [functionsMixins],
  components: {ProductionOrderStepDialog, StepActionDialog},
  data() {
    return {
      ui,
      StatusStepType,
      FlowStepNotSequenceActionType,
      StatusProductionOrderType,
      stepsFlowLoadingFinish: false,
      stepsFlow: [],
      stepsAll: [],
      stepCurrentId: 0,
      dialogStepDetailShow: false,
      dialogStepDetailId: 0,
      statusProductionColor: "",
      statusProduction: "",
      statusBatch: 0,
      statusOrder: 0,
    }
  },
  props: {
    productionOrderBatchId: {
      type: Number,
      default: 0,
      required: true,
    },
    enableChangeStatusOperation: Boolean,
    maxHeightSteps: {
      type: String,
      default: '',
    },
    currentPage: {},
    busy: Boolean,
    originOrderForm: Boolean,//Origem no cabeçalho da ordem de fabricação
    originStepForm: Boolean,//Origem nas etapas da ordem de fabricação

  },
  async mounted() {

    await this.getFlowByBatchId()


  },
  methods: {

    async getFlowByBatchId() {

      this.stepsFlowLoadingFinish = false

      if (!this.busy && this.productionOrderBatchId > 0 && this.productionOrderBatchId !== null) {

        await ProductionOrderBatchService.getFlowByBatchId(this.productionOrderBatchId).then((list) => {

          this.stepsFlow = list

          //1º Tentativa excluindo etapas em paralelo
          const stepCurrentNotParallel = this.stepsFlow.find(a => a.statusStep === StatusStepType.type.CURRENT && a.typeActionNotSequential !== FlowStepNotSequenceActionType.type.EXECUTION_PARALLEL)

          if (stepCurrentNotParallel !== null && stepCurrentNotParallel !== undefined) {
            this.stepCurrentId = stepCurrentNotParallel.productionOrderBatchStepId
            this.$emit('onGetStepCurrentId', this.stepCurrentId)
          } else {

            //2ª Tentativa qualquer etapa em andamento incluindo etapas em paralelo
            const stepCurrentAny = this.stepsFlow.find(a => a.statusStep === StatusStepType.type.CURRENT)

            if (stepCurrentAny !== null && stepCurrentAny !== undefined) {
              this.stepCurrentId = stepCurrentAny.productionOrderBatchStepId
              this.$emit('onGetStepCurrentId', this.stepCurrentId)
            }


          }

          if (this.stepsFlow.length > 0) {

            //Todas as etapas possuem o status operacional do lote e por tanto qualquer uma poderá obter os seguintes dados:
            const stepFirst = this.stepsFlow[0]

            this.statusProduction = stepFirst.statusProduction
            this.statusProductionColor = stepFirst.statusProductionColor
            this.statusBatch = stepFirst.statusBatch
            this.statusOrder = stepFirst.statusOrder

          }

          this.stepsFlowLoadingFinish = true

        }).catch(error => this.responseError(error))

      }

    },

    async onSubmitStepAction() {

      await this.getFlowByBatchId()
      ui.toast(this, "Status operacional alterado com sucesso!")

    },

    openDialogStepDetail(id) {

      this.dialogStepDetailShow = true
      this.dialogStepDetailId = id
      this.openModal('modal-production-order-step-detail')

    },

    stepActionSetOperationStatus() {

      if (this.enableChangeStatusOperation) {
        this.openDialogForm('modal-action-step-set-operation-status')
      } else {
        ui.msgError(this, 'Desculpe, você não possui acesso a alteração manual do status operacional')
      }


    }

  },
  watch: {
    async productionOrderBatchId() {
      await this.getFlowByBatchId()
    },
    async busy() {
      await this.getFlowByBatchId()
    }
  }

}
</script>